<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'About'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">Transforming Global Diagnostics</div>
				<div class="txt">A leader in IVD R&D, manufacturing, and supply chain.</div>
			</div>
			<!--块1-->
			<!--banner-->
			<div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/banner-img@2x.webp" />
			</div>
			<!--banner-->
			<!--块2-->
			<div class="block_2">
				<div class="left">
					<div class="txt"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						CorDx manufactures point-of-care and over-the-counter rapid diagnostic products across a variety of categories, including infectious disease, reproductive & sexual health, substance abuse, and other health and marker tests. With authorization for use in the US (FDA), Europe (CE Mark) and China (NMPA), CorDx tests are known for their comfort, speed and accuracy. The flagship three-in-one test for Flu A/B & COVID-19 features a more comfortable synthetic nasal swab and provides reliable results in just 10 minutes. 
					</div>
					<div class="txt"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Since 2006, CorDx has developed diagnostic products while establishing a solid supply chain foundation, allowing it to provide better quality, more affordable tests for distributors, healthcare providers and patients alike. 
					</div>
					<div class="txt"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						CorDx is pleased to announce that we have been relocated from <span>9540 Waples St #C, San Diego, CA 92121</span> to our new address <span>5900 Windward Parkway, Alpharetta, GA 30005</span>
					</div>
					<div class="txt"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>
						This move marks an exciting step forward as we continue to expand our operations and better serve our customers and partners. Please update your records to reflect our new headquarters location.
					</div>
				</div>
				<div class="right">
					<iframe width="570" height="320" src="https://www.youtube.com/embed/627TROwVV-8" title="CorDx Contract Manufacturing | End-to-End IVD Production" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="left">
					<div class="tit">Company Highlights</div>
					<div class="left_main">
						<div class="left_main_el">
							<div class="tit">20+</div>
							<div class="txt">YEARS OF EXPERIENCE</div>
						</div>
						<div class="left_main_el">
							<div class="tit">1000+</div>
							<div class="txt">INNOVATIVE PRODUCTS</div>
						</div>
						<div class="left_main_el">
							<div class="tit">700+</div>
							<div class="txt">GLOBAL PARTNERS</div>
						</div>
					</div>
				</div>
				<div class="right">
					<img src="../../assets/img/蒙版组 2@2x.webp" />
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="left">
					<div class="block_4_el" style="background-color: #FEFCFC;"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Integrated Supply Chain​</div>
						<div class="txt">Today’s supply chains are complex. CorDx owns its supply chain from bottom to top to ensure the world has access to Affordable, Use-friendly & Precision diagnostics products offered at competitive pricing.</div>
						<div class="txt">Integrated supply chain benefits:</div>
						<ul class="list">
							<li>● Quality Control​</li>
							<li>● Accessibility</li>
							<li>● Cost Savings​</li>
							<li>● Flexibility</li>
						</ul>
						<div class="btn_box_more btn_box" @click="goContact">
							Contact Us to Learn More<img src="../../assets/img/组 32@2x.png" />
						</div>
						<div class="img_box">
							<img src="../../assets/img/蒙版组 1@2x_副本.webp" />
						</div>
					</div>
					<div class="block_4_el" style="background-color: #FEFBF3;"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Technology & Expertise​</div>
						<div class="txt">CorDx has expertise in using industry standard and cutting-edge technologies to develop innovative IVD solutions. </div>
						<ul class="list">
							<li>● Colloidal gold</li>
							<li>● Electrochemical</li>
							<li>● Chemiluminescence</li>
							<li>● Dry clinical chemistry</li>
							<li>● PCR</li>
							<li>● Microfluidics</li>
							<li>● Recombinant protein</li>
							<li>● And more​</li>
						</ul>
						<div class="btn_box_more btn_box" @click="goContact">
							Contact Us to Learn More<img src="../../assets/img/组 32@2x.png" />
						</div>
						<div class="img_box">
							<img src="../../assets/img/蒙版组 1@2x (2)_副本.webp" />
						</div>
					</div>
				</div>
				<div class="right">
					<div class="block_4_el" style="background-color: #FBFEFC;margin-top: 0;"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="img_box">
							<img src="../../assets/img/img@2x.webp" />
						</div>
						<div class="tit" style="padding-top: 20px;">Partner with CorDx​​</div>
						<div class="txt">We partner with organizations around the world to develop, manufacture, and distribute diagnostics that empower users to monitor and improve their health.</div>
						<div class="txt"> Through these partnerships, we can best serve those who need it with collaboration, insight, and effectiveness. Do you have a breakthrough you believe will benefit <br />from collaboration with CorDx?</div>
						<div class="btn_box_more btn_box" @click="goPartnering">
							Learn More<img src="../../assets/img/组 32@2x.png" />
						</div>
					</div>
					<div class="block_4_el" style="background-color: #FBFEFC;"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="img_box">
							<img src="../../assets/img/image03@2x.webp" />
						</div>
						<div class="tit" style="padding-top: 20px;">Materials & Consumables</div>
						<div class="txt">CorDx provides raw IVD materials and consumables for:</div>
						<ul class="list">
							<li>● Rapid testing products</li>
							<li>● Biomarkers</li>
							<li>● Laboratory and research use​</li>
							<li>● Point-of-care diagnostic testing</li>
							<li>● Clinical research</li>
							<li>● And more</li>
						</ul>
						<div class="btn_box_more btn_box" @click="goContact">
							Contact Us to Learn More<img src="../../assets/img/组 32@2x.png" />
						</div>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="block_5_main">
					<div class="title"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>CorDx Union</div>
					<div class="text"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
					>CorDx is a CorDx Union company, a biotechnology organization that delivers medical device solutions to healthcare industries and over a billion users in more than 170 countries. CorDx Union provides full-cycle support from life’s conception to its completion. Outside of healthcare, CorDx Union propels innovations in energy, AI quality management, and other platforms.</div>
					<div class="text"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>Each member plays an important role in the CorDx ecosystem, all anchored around a vertically integrated supply chain that ensures users have access to the products they need when they need them.</div>
					<div class="block_5_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="block_5_box_el" style="z-index: 2;">
							<div @click="goWeb('https://cordx.com/')">
								<img src="../../assets/link_20241217/CorDx.webp" />
							</div>
							<div @click="goWeb('https://al21.com/')">
								<img src="../../assets/link_20241217/AL21.webp" />
							</div>
							<div @click="goWeb('https://ucreagent.com/')">
								<img src="../../assets/link_20241217/ucreagent.webp" />
							</div>
						</div>
						<div class="block_5_box_el" style="top: 20px;z-index: 1;">
							<div v-if="false" @click="goWeb('https://coretests.com/')">
								<img src="../../assets/link_20241217/coretests2.webp" />
							</div>
							<div @click="goWeb('https://bonore.com/')">
								<img src="../../assets/link_20241217/bonore.webp" />
							</div>
							<div @click="goWeb('https://www.abiores.com')">
								<img src="../../assets/link_20241217/Abiores.webp" />
							</div>
							<div @click="goWeb('https://cupet.com/')">
								<img src="../../assets/link_20241217/Cupet.webp" />
							</div>
						</div>
						<!-- <div class="block_5_el" @click="goWeb('https://cordx.com/')">
							<img src="../../assets/img/组 316@2x.png" />
							<div class="tit">CorDx</div>
							<div class="txt">Diagnostic platform for innovation, manufacturing, and supply.</div>
						</div>
						<div class="block_5_el" @click="goWeb('https://coretests.com/')">
							<img src="../../assets/img/组 316@2x (1).png" />
							<div class="tit">Core tests</div>
							<div class="txt">Precision, reliable, and use-friendly testing solutions for IVD and more.</div>
						</div>
						<div class="block_5_el" @click="goWeb('https://jtests.com/')">
							<img src="../../assets/img/组 316@2x (2).png" />
							<div class="tit">Jtests</div>
							<div class="txt">Raw materials for diagnostic research, development, and production.</div>
						</div>
						<div class="block_5_el" @click="goWeb('https://www.abiores.com/en/')">
							<img src="../../assets/img/组 316@2x (3).png" />
							<div class="tit">Abiores</div>
							<div class="txt">PCR solutions for diagnostic testing, research, and development.</div>
						</div>
						<div class="block_5_el" @click="goWeb('https://bonoplastics.com/')">
							<img src="../../assets/img/组 316@2x (4).png" />
							<div class="tit">Bono Plastics</div>
							<div class="txt">Consumable supplies and resources for diagnostic production and development.</div>
						</div>
						<div class="block_5_el" @click="goWeb('https://en.cupet.com/')">
							<img src="../../assets/img/组 589@2x.png" />
							<div class="tit">CuPet</div>
							<div class="txt">One-Stop Animal Diagnostic Solutions.</div><br />
						</div> -->
					</div>
				</div>
			</div>
			<!--块5-->
			<!--块6-->
			<div class="block_6"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="msg_box">
					<div class="tit">Propose a Partnership</div>
					<div class="txt">Join us and change the world of diagnostics</div>
					<div class="btn_box_more btn_box" @click="goContact">
						Contact Us<img src="../../assets/img/组 32@2x.png" />
					</div>
				</div>
				<div class="img_box">
					<img src="../../assets/img/背景图@2x.webp" />
				</div>
			</div>
			<!--块6-->
			<!--块7-->
			<div class="block_7"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_7_main">
					<div class="title">Recent News</div>
					<div class="block_7_box">
						<div
							v-for="(value, index) in newsData"
							:key="index"
							class="block_7_el"
							@mouseover="newsOver(value.id)"
							@mouseleave="newsLeave"
							@click="goResourcesInfo(value)"
						>
							<img :src="value.image" />
							<div class="msg_box">
								<div class="txt">{{ value.title }}</div>
							</div>
							<div class="time">{{ value.fabu_time }}</div>
							<div v-if="isShow == value.id" class="mask_box"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="mask_tit">{{ value.title }}</div>
								<div class="mask_txt">{{ value.description }}</div>
							</div>
						</div>
					</div>
					<div class="btn_box_more" style="position: absolute;left: 50%;transform: translate(-50%, 0px);" @click="goResources">
						View More<img src="../../assets/img/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块7-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { resourcesList } from '@/api/public';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isShow: null,
			newsData: [],  //新闻数据
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		resourcesList({
			catid: 1,
			page: 1,
			page_size: 3,
			language: sessionStorage.getItem('lang'),
		}).then(res2 => {
			that.newsData = res2.data.data;
		});
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击进去新闻详情
		goResourcesInfo(value) {
			let that = this;
			// let { href } = that.$router.resolve({
			// 	path: '/resources-info',
			// 	query: {
			// 		id: value.unionid,
			// 	}
			// });
			// window.open(href, '_blank');
			let routeData = that.$router.resolve({name: "Resourcesinfo", params: { resourcesInfoId: value.custom } });
			window.open(routeData.href, '_blank');
		},
		//新闻滑入
		newsOver(value) {
			let that = this;
			that.isShow = value;
		},
		//新闻滑出
		newsLeave() {
			let that = this;
			that.isShow = null;
		},
		//跳转外站
		goWeb(value) {
			let that = this;
			window.open(value, '_blank');
		},
		goPartnering() {
			this.$router.push({ path: '/partnering', });
		},
		goContact() {
			this.$router.push({ path: '/contact', });
		},
		goResources() {
			this.$router.push({ path: '/resources', });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块7*/
	.block_7{
		width: 100%;
		background-color: transparent;
		background-image: linear-gradient(180deg,  #F1ECE6 20%, #FFFFFF 100%);
		.block_7_main{
			width: 1140px;
			margin: 0 auto;
			padding: 100px 0 150px 0;
			.block_7_box{
				display: flex;
				padding: 60px 0 50px 0;
				.block_7_el{
					flex: 1;
					position: relative;
					margin: 0 20px;
					background-color: #ffffff;
					box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
					cursor: pointer;
					overflow: hidden;
					.mask_box{
						position: absolute;
						width: 100%;
						height: 100%;
						top: 0;
						background-color: #ffffff;
						padding: 34px;
						.mask_tit{
							font-size: 20px;
							color: #000000;
						}
						.mask_txt{
							padding-top: 40px;
							font-size: 16px;
							color: #706B69;
						}
					}
					.msg_box{
						width: 100%;
						padding: 30px 34px 120px 34px;
						border-top: 2px solid #0B318F;
						.txt{
							color: #000000;
							font-size: 22px;
						}
					}
					.time{
						position: absolute;
						z-index: 2;
						bottom: 40px;
						left: 34px;
						font-size: 18px;
						color: #706B69;
					}
					img{
						width: 100%;
						// height: auto;
						height: 227px;
						object-fit: cover;
					}
				}
			}
			.title{
				font-size: 45px;
				color: #000000;
			}
		}
	}
	/*块6*/
	.block_6{
		width: 100%;
		.msg_box{
			width: 1140px;
			margin: 0 auto;
			padding: 100px 0 50px 0;
			text-align: center;
			.btn_box{
				margin-top: 40px;
			}
			.txt{
				font-size: 30px;
				color: #000000;
			}
			.tit{
				font-size: 65px;
				color: #000000;
			}
		}
		.img_box{
			img{ width: 100%; }
		}
	}
	/*块5*/
	.block_5{
		width: 100%;
		padding: 80px 0 10px 0;
		background-color: #F2F7FD;
		.block_5_main{
			.block_5_box{
				position: relative;
				padding-top: 50px;
				padding-bottom: 50px;
				.block_5_box_el{
					position: relative;
					display: flex;
					justify-content: center;
					div{
						padding: 0 10px;
						cursor: pointer;
						img{
							width: 300px;
						}
					}
				}
				// .block_5_el{
				// 	width: 31%;
				// 	height: 240px;
				// 	display: inline-block;
				// 	margin: 10px;
				// 	padding: 20px 15px;
				// 	background-color: #ffffff;
				// 	text-align: center;
				// 	cursor: pointer;
				// 	.txt{
				// 		padding-top: 10px;
				// 		font-size: 15px;
				// 		color: #706B69;
				// 	}
				// 	.tit{
				// 		font-size: 20px;
				// 		color: #000000;
				// 	}
				// 	img{
				// 		width: 70%;
				// 	}
				// }
			}
			.text{
				width: 1140px;
				margin: 0 auto;
				padding-top: 20px;
				color: #000000;
				font-size: 18px;
			}
			.title{
				width: 1140px;
				margin: 0 auto;
				padding-bottom: 20px;
				font-size: 45px;
				color: #000000;
			}
		}
	}
	/*块4*/
	.block_4{
		width: 1140px;
		margin: 0 auto;
		padding: 100px 0;
		display: flex;
		.left, .right{
			flex: 1;
			margin: 0 20px;
			.block_4_el{
				margin-top: 50px;
				padding: 40px;
				.img_box{
					img{ width: 100%; }
				}
				.btn_box{
					margin: 20px 0;
				}
				.list{
					padding-top: 20px;
					li{
						padding: 4px 0;
					}
				}
				.txt{
					padding-top: 20px;
					font-size: 18px;
					color: #000000;
				}
				.tit{
					font-size: 45px;
					color: #000000;
				}
			}
		}
	}
	/*块3*/
	.block_3{
		width: 1140px;
		margin: 0 auto;
		display: flex;
		.left{
			flex: 1;
			padding: 40px 30px;
			background-color: #0066D4;
			color: #ffffff;
			.left_main{
				display: flex;
				height: 160px;
				width: 100%;
				margin-top: 15px;
				align-items: center;
				text-align: center;
				.left_main_el{
					flex: 1;
					height: 100%;
					margin: 0 8px;
					padding-top: 28px;
					background-color: #ffffff;
					.tit{
						font-size: 45px;
						color: #0B318F;
						font-weight: bold;
					}
					.txt{
						font-size: 18px;
						color: #0B318F;
					}
				}
			}
			.tit{
				font-size: 45px;
			}
		}
		.right{
			width: 210px;
			img{ width: 100%; }
		}
	}
	/*块2*/
	.block_2{
		width: 1140px;
		margin: 0 auto;
		padding: 70px 0px 100px 0px;
		color: #000000;
		display: flex;
		.right{
			flex: 1;
			padding-top: 30px;
		}
		.left{
			flex: 1;
			padding-right: 30px;
			.txt{
				padding-top: 30px;
				font-size: 18px;
				span{
					font-size: 18px;
					font-weight: bold;
				}
			}
		}
	}
	/*banner*/
	.banner_box{
		img{
			width: 100%;
		}
	}
	/*块1*/
	.block_1{
		width: 1140px;
		margin: 0 auto;
		padding: 50px 50px 0 50px;
		color: #000000;
		text-align: center;
		.tit{
			font-size: 65px;
		}
		.txt{
			font-size: 30px;
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: #FFFFFF;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
